import React from 'react';
import { getCategoryIcon } from '../lib/categoryIcons';

export default function CategoryCard({ category, onClick }) {
  // Resolve icon from the central registry. Accepts either the lucide name
  // ("UtensilsCrossed") stored in `category.icone` or the slug ("alimentos")
  // — getCategoryIcon handles both, with a fallback to Building2.
  const Icon = getCategoryIcon(category.icone || category.id);

  return (
    <div
      onClick={onClick}
      className="bg-white hover:bg-[#F3E8FF] border border-[var(--border)] hover:border-[#56007F]/20 rounded-xl p-2 h-24 flex flex-col items-center justify-center gap-1 transition-all cursor-pointer group"
      data-testid={`category-card-${category.id}`}
    >
      <div className="w-8 h-8 rounded-full bg-[#F3E8FF] group-hover:bg-[var(--primary)] flex items-center justify-center transition-colors">
        <Icon className="w-4 h-4 text-[var(--primary)] group-hover:text-white transition-colors" />
      </div>
      <span className="text-[11px] font-medium text-center leading-tight line-clamp-2 text-[var(--text-primary)] group-hover:text-[var(--primary)] transition-colors">
        {category.nome}
      </span>
    </div>
  );
}
